import configureCommands from "./configure-commands"
import { createInvokerWithCache } from '@drapejs/core'

configureCommands(createInvokerWithCache());